import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('water-control/index', {params});
    },
    getChart(params) {
        return Service().get('water-control/get-chart', {params});
    },
    show(id) {
        return Service().get('water-control/show/'+id);
    },
    create(params) {
        return Service().post('water-control/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('water-control/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('water-control/delete/'+id);
    },
    machineDetail(params) {
        return Service().get('water-control/machine-detail', {params});
    },
}